// Типовете на човешкия „разказ" за един одит запис + безопасните достъпи до
// нетипизирания payload. Изнесени от `interpret.ts`, за да могат и модулните
// интерпретатори (`interpretInventory.ts`, `interpretSystem.ts`) да ги ползват
// без кръгов импорт: `interpret.ts` вика тях, всички те ползват този файл.
//
// Тук няма нито едно име на поле от API-то — те живеят само в `contract.ts`.

import { TRUNCATED } from "./contract";

export type Tone = "neutral" | "add" | "remove" | "discount" | "money" | "info";

export interface Fact {
  label: string;
  value: string;
  tone?: Tone;
  /** true → рендира се като един ред "етикет: стойност", не в grid колона. */
  inline?: boolean;
}

/** Добавка към продуктов ред — изнесена структурно за подравнени колони. */
export interface AddonLine {
  qty: string;
  name: string;
  unit?: string;
  total: string;
}

export interface Line {
  qty?: string;
  name: string;
  unit?: string;
  total?: string;
  tone?: Tone;
  /** Добавки (количество × ед. цена → сума), подравнени под продукта. */
  addons?: AddonLine[];
  /** Текстови бележки: отстъпка, модификатор. */
  subs?: string[];
}

export interface HumanStory {
  /** Категория — определя иконата/тоналния нюанс в модала. */
  kind: string;
  tone: Tone;
  facts: Fact[];
  lines: Line[];
  linesLabel?: string;
  note?: string;
  total?: string;
  totalLabel?: string;
  /** false → не можахме да разчетем тялото; модалът подканва към суровия запис. */
  interpreted: boolean;
}

/** Празен разказ от даден вид — точката, от която всеки интерпретатор тръгва. */
export function emptyStory(kind: string, tone: Tone): HumanStory {
  return { kind, tone, facts: [], lines: [], interpreted: true };
}

// ── Безопасни достъпи до нетипизирания payload ──────────────────────────────

export function asObj(x: unknown): Record<string, unknown> | null {
  return x && typeof x === "object" && !Array.isArray(x)
    ? (x as Record<string, unknown>)
    : null;
}

export function asArr(x: unknown): unknown[] {
  return Array.isArray(x) ? x : [];
}

export function field(obj: unknown, key: string): unknown {
  return asObj(obj)?.[key];
}

export function asString(x: unknown): string | null {
  return typeof x === "string" && x.trim() ? x : null;
}

export function isTruncated(x: unknown): boolean {
  return asObj(x)?.[TRUNCATED.flag] === true;
}
